import React from 'react';
import { Eye, Edit3, Printer } from 'react-feather';
import { makeStyles } from '@material-ui/core/styles';

const MenuLinhaTabela = ({ edicaoAtiva, impressaoAtiva, baixarImagemBiopsiaAtiva, baixarImagemAssinaturaAtiva, handleClickVisualizacao, handleClickEdicao, handleClickImprimir, handleClickBaixarImagemBiopsia, handleClickBaixarAssinaturaDigital, handleClickGerarReciboRecolhimento, baixarReciboRecolhimento }) => {
    const classes = useStyles();

    const tamanhoIcones = 20;
    const itensMenu = [
        {
            title: 'Visualizar',
            icone: <Eye title='Visualizar' size={tamanhoIcones} className={classes.iconeMenu} />,
            click: handleClickVisualizacao,
            visivel: true
        },

        {
            title: 'Editar Lote',
            icone: (
                <Edit3 size={tamanhoIcones} className={classes.iconeMenu} />
            ),
            click: handleClickEdicao,
            visivel: edicaoAtiva
        },

        {
            title: 'Imprimir',
            icone: (
                <Printer size={tamanhoIcones} className={classes.iconeMenu} />
            ),
            click: handleClickImprimir,
            visivel: impressaoAtiva
        },

        {
            title: 'Download foto bag',
            icone: (
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 198.931 198.931" width="17" heigth="17" className={classes.iconeDownload}>

			<path d="M99.469,69.561c-25.423,0-46.104,20.683-46.104,46.104s20.683,46.104,46.104,46.104
				c25.421,0,46.104-20.683,46.104-46.104S124.89,69.561,99.469,69.561z M99.469,146.91c-17.229,0-31.245-14.017-31.245-31.245
				c0-17.228,14.017-31.245,31.245-31.245c17.228,0,31.245,14.017,31.245,31.245C130.714,132.892,116.698,146.91,99.469,146.91z"/>
			<path d="M175.499,44.681h-72.315h-3.715V27.956c0-9.393-7.64-17.036-17.033-17.036H44.247c-9.393,0-17.033,7.642-17.033,17.036
				v16.726h-3.777C10.515,44.681,0,55.194,0,68.116v96.465c0,12.92,10.515,23.43,23.437,23.43h152.059
				c12.925,0,23.435-10.51,23.435-23.43V68.116C198.934,55.194,188.421,44.681,175.499,44.681z M42.07,27.956
				c0-1.201,0.976-2.176,2.177-2.176h38.189c1.199,0,2.174,0.976,2.174,2.177v16.726H42.07V27.956z M175.499,173.152H23.437
				c-4.73,0-8.578-3.846-8.578-8.571V68.116c0-4.73,3.848-8.576,8.578-8.576h5.451H42.07h42.538h18.573h72.315
				c4.73,0,8.576,3.846,8.576,8.576v96.465h0.003C184.075,169.306,180.229,173.152,175.499,173.152z"/>
			<rect x="156.012" y="71.816" width="18.989" height="14.859"/>

                </svg>
            ),
            click: handleClickBaixarImagemBiopsia,
            visivel: baixarImagemBiopsiaAtiva
        },

        {
            title: 'Download Assinatura Cliente',
            icone: (
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" width="15" heigth="15" className={classes.iconeDownload}><path  d="M256 0v128h128L256 0zM224 128L224 0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V160h-127.1C238.3 160 224 145.7 224 128zM64 72C64 67.63 67.63 64 72 64h80C156.4 64 160 67.63 160 72v16C160 92.38 156.4 96 152 96h-80C67.63 96 64 92.38 64 88V72zM64 136C64 131.6 67.63 128 72 128h80C156.4 128 160 131.6 160 136v16C160 156.4 156.4 160 152 160h-80C67.63 160 64 156.4 64 152V136zM304 384c8.875 0 16 7.125 16 16S312.9 416 304 416h-47.25c-16.38 0-31.25-9.125-38.63-23.88c-2.875-5.875-8-6.5-10.12-6.5s-7.25 .625-10 6.125l-7.75 15.38C187.6 412.6 181.1 416 176 416H174.9c-6.5-.5-12-4.75-14-11L144 354.6L133.4 386.5C127.5 404.1 111 416 92.38 416H80C71.13 416 64 408.9 64 400S71.13 384 80 384h12.38c4.875 0 9.125-3.125 10.62-7.625l18.25-54.63C124.5 311.9 133.6 305.3 144 305.3s19.5 6.625 22.75 16.5l13.88 41.63c19.75-16.25 54.13-9.75 66 14.12c2 4 6 6.5 10.12 6.5H304z"/></svg>
            ),
            click: handleClickBaixarAssinaturaDigital,
            visivel: baixarImagemAssinaturaAtiva
        },

        {
            title: 'Download Recibo Recolhimento',
            icone: (
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="15" heigth="15" className={classes.iconeDownload}><path d="M402 2.22c-8.5-3.953-18.53-2.547-25.66 3.578l-39.13 33.53l-32.28-32.28C296.5-1.42 283.1-2.342 273.6 4.814L224 42.01l-49.59-37.2C164.9-2.311 151.5-1.389 143 7.048L110.8 39.33L71.63 5.798c-7.109-6.125-17.17-7.531-25.66-3.578C37.45 6.126 32 14.64 32 24.02v463.1c0 9.374 5.453 17.89 13.97 21.8c8.484 3.937 18.55 2.531 25.66-3.578l39.13-33.53l32.28 32.28c8.438 8.468 21.81 9.359 31.38 2.234L224 469.1l49.59 37.2c9.562 7.156 22.92 6.265 31.38-2.234l32.28-32.28l39.13 33.53c4.438 3.812 10 5.781 15.62 5.781c3.406 0 6.828-.7187 10.03-2.203C410.5 505.9 416 497.4 416 487.1V24.02C416 14.64 410.5 6.126 402 2.22zM368 435.8l-16.38-14.03c-9.531-8.171-23.7-7.625-32.59 1.25l-33.28 33.28L238.4 420.8C234.1 417.6 229.1 415.1 224 415.1S213.9 417.6 209.6 420.8l-47.34 35.51l-33.28-33.28c-8.875-8.874-23.05-9.421-32.59-1.25L80 435.8V76.2L96.38 90.23c9.547 8.187 23.72 7.656 32.59-1.25l33.28-33.28l47.34 35.51c8.531 6.406 20.28 6.406 28.81 0l47.34-35.51l33.28 33.28c8.891 8.906 23.06 9.437 32.59 1.25L368 76.2V435.8zM312 160h-176c-8.844 0-16 7.156-16 15.1s7.156 15.1 16 15.1h176c8.844 0 16-7.156 16-15.1S320.8 160 312 160zM312 319.1h-176c-8.844 0-16 7.156-16 15.1c0 8.843 7.156 15.1 16 15.1h176c8.844 0 16-7.156 16-15.1C328 327.2 320.8 319.1 312 319.1zM312 240h-176c-8.844 0-16 7.156-16 15.1c0 8.843 7.156 15.1 16 15.1h176c8.844 0 16-7.156 16-15.1C328 247.2 320.8 240 312 240z"/></svg>
            ),
            click: handleClickGerarReciboRecolhimento,
            visivel: baixarReciboRecolhimento
        },
    ];

    return (
        itensMenu.filter(item => item.visivel).length
        && <div className={classes.contentMenu}>
            {itensMenu
                .filter(item => item.visivel)
                .map((item, idx) => (
                    <div
                        onClick={item.click}
                        key={item.title}
                        title={item.title}
                        className={idx === 0 ? classes.primeiroIcone : classes.spanIcone}
                    >
                        {item.icone}
                    </div>
                ))}
        </div>
    );
}


const useStyles = makeStyles({
    contentMenu: {
        display: 'flex',
        flexDirection: 'row'
    },
    spanIcone: {
        paddingLeft: '20px',
        cursor: 'pointer'
    },
    primeiroIcone: {
        paddingLeft: '10px',
        cursor: 'pointer'
    },
    iconeMenu: {
        color: 'white',
        cursor: 'pointer',
        '&:hover': {
            color: '#BF43AB'
        },
        display: "flex"
    },
    iconeDownload: {
        fill: 'white',
        '&:hover': {
            fill: '#BF43AB'
        },
    }
});

export default MenuLinhaTabela;